export default __webpack_public_path__ + "static/media/57_mobile.febc8fa6.jpg";